import angular from 'angular';

// TODO find a better name
import OnFocusDirective, { selector } from './on-focus.directive';

export default angular
    .module('application.directive.on-focus', [])
    .directive(selector, OnFocusDirective);



// WEBPACK FOOTER //
// ./src/application/directive/on-focus/index.js